export default "__VITE_ASSET__46713e99__"